import axios from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';
import { getActiveMemberId } from './active-member';

const baseURL = import.meta.env['VITE_API_BASE_URL'] as string | undefined;

export const apiClient = axios.create({
  baseURL: baseURL ?? '/api',
});

apiClient.interceptors.request.use(async (config) => {
  try {
    const session = await fetchAuthSession();
    const token = session.tokens?.idToken?.toString();
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
  } catch {
    // Not authenticated — let the request proceed without a token
  }
  // When acting as a shared-device user, tell the API whose chores to act on.
  // The server validates this against the signed-in principal before honouring it.
  const actingAs = getActiveMemberId();
  if (actingAs) {
    config.headers['X-Acting-As'] = actingAs;
  }
  return config;
});
